/* eslint-disable no-autofix/jsdoc/require-jsdoc */
import { getTsWarehousingConsignmentsClient } from '@/api/warehousing-consignments.client';
import getAuthBearerToken from '@montugroup/circuit-shared/utils/getAuthBearerToken';
import { isErrorResponse } from '@ts-rest/core';

export type UseGetPharmacistShipmentsParams = {
  id: string;
};

const {
  getConsignment: { useQuery, keys },
} = getTsWarehousingConsignmentsClient();
// Fetches a specific shipment for the pharmacist
const useGetPharmacistShipment = (id: string) =>
  useQuery({
    queryKey: [...keys, id],
    queryData: {
      params: { consignmentId: id },
      headers: { authorization: getAuthBearerToken() },
    },
    retry: (count: number, error: unknown) => {
      if (isErrorResponse(error)) {
        if (count < 3 && error.status === 500) {
          return true;
        }
      }
      return false;
    },
    meta: {},
  });

export default useGetPharmacistShipment;
